import { useMutation } from '@tanstack/react-query';
import { useBoundStore } from '@Store/useBoundStore';
import { HttpService } from '@Services/index';

const consentsData = [{ name: 'general', type: 'AUTHORIZED_VIEWER_TERM', version: '1.0' }];

export const useAuthorizedUserConsent = () =>
  useMutation({
    mutationFn: async () => {
      const { customerId, authorizedUserId } = useBoundStore.getState().onboardingSlice;
      const consentFormData = useBoundStore.getState().getConsentFormData();
      const imageBlob = consentFormData as Blob;
      const formData = new FormData();
      formData.append(
        'consents',
        new Blob([JSON.stringify(consentsData)], { type: 'application/json' })
      );
      formData.append('image', imageBlob);

      const url = customerId
        ? `v1/user/${customerId}/authorized/user/${authorizedUserId}/terms_and_conditions/consent`
        : `v1/accountant/${authorizedUserId}/terms_and_conditions/consent`;

      // Auth comes from the onboardingToken cookie (the route is in ONBOARDING_AUTH_PATHS).
      await HttpService.post(url, formData);
    },
  });
